module.exports = __webpack_public_path__ + "images/free-access-trial/appillustrations-1.png";